import { render, staticRenderFns } from "./FmSplit.vue?vue&type=template&id=99f89052&"
import script from "./FmSplit.vue?vue&type=script&lang=js&"
export * from "./FmSplit.vue?vue&type=script&lang=js&"
import style0 from "./FmSplit.vue?vue&type=style&index=0&id=99f89052&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports